import React from "react";
import SitePage from "../SitePage";
import { RotateCcw, CheckCircle2, XCircle, MessageCircle } from "lucide-react";

const openChat = () => window.dispatchEvent(new CustomEvent("djk:open-chat"));

export default function ResiPage() {
  return (
    <SitePage
      testId="resi-page"
      breadcrumb="Help"
      breadcrumbLabel="Resi"
      eyebrow="RESI / 返品"
      title="Diritto di"
      accent="ripensarci"
      subtitle="Hai 14 giorni dalla ricezione dell&apos;ordine per rimandarci indietro il pezzo, senza spiegare perché. Diritto di recesso pieno, come previsto dal Codice del Consumo (D.Lgs. 21/2014)."
    >
      <div className="space-y-14 text-zinc-300 leading-relaxed">
        {/* How it works */}
        <div>
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-4">COME PROCEDERE</div>
          <ol className="space-y-4">
            {[
              "Entro 14 giorni dalla consegna, scrivici via chat o email indicando il numero d&apos;ordine.",
              "Ti rispondiamo con il modulo di reso compilabile e l&apos;indirizzo di ritorno.",
              "Rimballi il pezzo nella confezione originale + scatola di spedizione, esattamente come ti è arrivato.",
              "Lo spedisci a tue spese con un corriere tracciato (raccomandato: assicurazione fino al valore del prodotto).",
              "Appena riceviamo il pacco e verifichiamo l&apos;integrità, ti rimborsiamo entro 14 giorni sullo stesso metodo di pagamento.",
            ].map((step, i) => (
              <li key={i} className="flex gap-4 bg-zinc-900/40 border border-zinc-800 p-4">
                <span className="font-mono text-yellow-400 shrink-0 text-lg">0{i + 1}</span>
                <span dangerouslySetInnerHTML={{ __html: step }} />
              </li>
            ))}
          </ol>
        </div>

        {/* Accettato / Non accettato */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div data-testid="resi-accepted" className="border-2 border-emerald-500/40 bg-emerald-500/5 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-emerald-500 text-black p-2">
                <CheckCircle2 className="w-5 h-5" strokeWidth={3} />
              </div>
              <div className="font-heading uppercase text-emerald-400 text-lg">Reso accettato se</div>
            </div>
            <ul className="space-y-2 text-sm">
              <li>· Prodotto integro, non usato, nella confezione originale sigillata</li>
              <li>· Tutti gli accessori, cartellini e bollini presenti</li>
              <li>· Comunicazione inviata entro 14 giorni dalla consegna</li>
              <li>· Rispedito entro ulteriori 14 giorni dalla comunicazione</li>
            </ul>
          </div>

          <div data-testid="resi-not-accepted" className="border-2 border-red-500/40 bg-red-500/5 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-red-500 text-black p-2">
                <XCircle className="w-5 h-5" strokeWidth={3} />
              </div>
              <div className="font-heading uppercase text-red-400 text-lg">Reso NON accettato se</div>
            </div>
            <ul className="space-y-2 text-sm">
              <li>· Scatola originale rovinata, sigillo strappato o mancante</li>
              <li>· Pezzo montato / assemblato / esposto</li>
              <li>· Prodotti su misura o personalizzati (escluso per legge)</li>
              <li>· Comunicazione oltre i 14 giorni</li>
            </ul>
          </div>
        </div>

        {/* Difetti */}
        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">PRODOTTO DIFETTOSO</div>
          <h2 className="font-heading uppercase text-2xl text-white mb-3">Se qualcosa non va</h2>
          <p>
            Se il pezzo arriva con un difetto di fabbrica o danneggiato dal trasporto, <strong className="text-yellow-400">le spese di reso sono a carico nostro</strong>.
            Fotografalo appena aprilo, mandaci gli scatti in chat entro 48 ore dalla consegna e ti organizziamo il ritiro senza costi.
            Rimborso o sostituzione, decidi tu.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center border-t-2 border-zinc-800 pt-10">
          <div className="bg-zinc-900 border-2 border-zinc-800 p-6 inline-block">
            <div className="flex items-center justify-center gap-3 mb-3">
              <RotateCcw className="w-5 h-5 text-yellow-400" strokeWidth={3} />
              <div className="font-heading uppercase text-white">Devi aprire un reso?</div>
            </div>
            <button data-testid="resi-cta-chat" onClick={openChat} className="skew-btn bg-yellow-400 text-black font-heading uppercase text-sm px-6 py-3 border-2 border-yellow-400 hover:bg-black hover:text-yellow-400 transition inline-flex items-center gap-2">
              <MessageCircle className="w-4 h-4" strokeWidth={3} /> <span>Contattaci ora</span>
            </button>
          </div>
        </div>
      </div>
    </SitePage>
  );
}
